import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { message } from "antd";

type Props = {
  styles: Object,
  createOrder: Function,
  onApprove: Function,
  payPalClientId: String,
  currency: String,
  country: String,
}

const PayPalCheckout = (props: Props) => {
  const {styles, createOrder, onApprove, payPalClientId, currency, country } = props;
  const env = process.env.REACT_APP_ENV;
  let initialOptions = {};
  if (env === "Production") {
    initialOptions = {
    "client-id": payPalClientId,
    currency: currency,
    intent: "capture",
    "enable-funding": "venmo",
    "disable-funding": "card,paylater",
  };
  } else if (env !== "Production") {
    initialOptions = {
    "client-id": payPalClientId,
    currency: currency,
    intent: "capture",
    "enable-funding": "venmo",
    "disable-funding": "card,paylater",
    "buyer-country": country,
  };
  }
  
  return (
   <PayPalScriptProvider options={initialOptions}>
     <PayPalButtons
       style={styles}
       createOrder={createOrder}
       onApprove={onApprove}
       onError={() =>
       message.error(
        "Please perform the required action and/or try again later."
        )
       }
    />
</PayPalScriptProvider>
);
};

export default PayPalCheckout;
